import AccessRightsTable from './AccessRightsTable';

export default AccessRightsTable;
